<div class="mi-home-wrraper mc-px-128">
    <div class="mi-home d-flex align-items-center justify-content-center">
        <div class="d-flex align-items-center flex-column">
            <div>
                <img src="assets/images/components/app/my-import-start-page.svg" [alt]="'my import'" />
            </div>
            <div>
                @if(translationsLoaded$|async){
                <mc-button class="mi-enter-button" [id]="'mi-enter-button'" [label]="genericText?.enter"
                    [ariaLabel]="genericText?.enter" (click)="enter()" miFocusOnTab>
                </mc-button>
                } @else{
                <div class="mi-home-skelton">
                    <mc-bar-skeleton [widthBar]="'100%'" [heightBar]="'3.5rem'"></mc-bar-skeleton>
                </div>

                }
            </div>
            <div class="mc-mt-40 d-flex d-sm-none">
                <div class="mc-mt-50 mi-home-rectangle-1">
                    <svg width="117" height="106" viewBox="0 0 117 106" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="33.2763" y="-2.9895" width="102.349" height="68.94" rx="10"
                            transform="rotate(31.5695 33.2763 -2.9895)" fill="#D7E7FE" fill-opacity="0.6" />
                    </svg>
                </div>
                <div class="mc-mt-100 mc-ms-55 mi-home-rectangle-2">
                    <svg width="87" height="64" viewBox="0 0 87 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="-0.907593" y="10.3591" width="81.5768" height="54.9481" rx="10"
                            transform="rotate(-8.00841 -0.907593 10.3591)" fill="#E4EFFE" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</div>